import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';

import UserInput from "ui/ReactUserInput";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";
import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";

const StatutoryAssessmentForm = React.forwardRef(({readOnly, displayErrors, child}, ref) =>
{
   const initialIsStatutoryReferralFlag = +(child.statutory_referral_flag) === 1;

   const [isStatutoryReferralFlag, setIsStatutoryReferralFlag] = useState(initialIsStatutoryReferralFlag)

   const InputIsStatutoryReferral = useRef(null);
   const InputStatutoryReferralStartDate = useRef(null);
   const InputStatutoryReferralEndDate = useRef(null);

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            statutory_referral_text: '',
            statutory_referral_flag: isStatutoryReferralFlag ? 1 : 0,
            dmy_statutory_referral_date: isStatutoryReferralFlag ? InputStatutoryReferralStartDate.current.getValue() : null,
            dmy_sr_proposed_end_date: isStatutoryReferralFlag ? InputStatutoryReferralEndDate.current.getValue() : null
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (isStatutoryReferralFlag)
      {
         if (!InputStatutoryReferralStartDate.current.isValid())
         {
            valid = false;
         }

         if (!InputStatutoryReferralEndDate.current.isValid())
         {
            valid = false;
         }
      }

      return valid;
   }

   const onChangeStatutoryReferral = (newValue) =>
   {
      setIsStatutoryReferralFlag(newValue);
   }

   const fromDateRow = () =>
   {
      const fromRequired = isStatutoryReferralFlag === true;

      return (
         <Fragment>
            <div key='sastart' className='col-md-6'>
               <UserInput validation={{required: fromRequired, maxlen: 10, isDate: true}}
                          id='InputStatutoryReferralStartDate'
                          name='InputStatutoryReferralStartDate'
                          key='InputStatutoryReferralStartDate'
                          ref={InputStatutoryReferralStartDate}
                          placeholder='DD/MM/YYYY'
                          labelText='Statutory Assessment Referral Date'
                          errorText='You must enter a valid date'
                          value={child.dmy_statutory_referral_date}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
            <div key='saend' className='col-md-6'>
               <UserInput validation={{required: fromRequired, maxlen: 10, isDate: true}}
                          id='InputStatutoryReferralEndDate'
                          name='InputStatutoryReferralEndDate'
                          key='InputStatutoryReferralEndDate'
                          ref={InputStatutoryReferralEndDate}
                          placeholder='DD/MM/YYYY'
                          labelText='Statutory Assessment Proposed End Date'
                          errorText='You must enter a valid date'
                          value={child.dmy_sr_proposed_end_date}
                          readOnly={readOnly}
                          displayErrors={displayErrors}/>
            </div>
         </Fragment>
      )
   }

   const isStatutoryReferralSection = () =>
   {
      return (
         <Fragment>
            <div key='' className='col-md-12'>
               <UserInputCheckbox
                  key='InputIsStatutoryReferral'
                  ref={InputIsStatutoryReferral}
                  label='Has there been a referral for statutory assessment?'
                  errorText='Has there been a referral for statutory assessment?'
                  defaultValue={initialIsStatutoryReferralFlag}
                  readOnly={readOnly}
                  onChange={onChangeStatutoryReferral}
                  displayErrors={displayErrors}/>
            </div>
         </Fragment>
      )
   }

   return (
      <BootstrapRow>
         <BootstrapCol width={12}>
            <FieldsetContainer title='Statutory Referral'>
               <BootstrapRow>
                  {isStatutoryReferralSection()}
                  {isStatutoryReferralFlag === true && fromDateRow()}
               </BootstrapRow>
            </FieldsetContainer>
         </BootstrapCol>
      </BootstrapRow>
   )
})

export default StatutoryAssessmentForm;
